export default __webpack_public_path__ + "static/media/settings-icon.2f55ee10.svg";